let familiar_structure = {
  familiars_name: '',
  familiars_relationship: '',
  familiars_age: ''
};

export default function() {
  Vue.component('mainform', {
    data() {
      return {
        familiars: [_.clone(familiar_structure)]
      }
    },
    methods: {
      addFamiliar() {
        this.familiars.push(_.clone(familiar_structure));
      }
    }
  });

  window.app.vm = new Vue({
    el: '#app',
  });
};
